import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import DataTable from '../../DataTable';
import * as api from '../../../actions/api';
import { getDisplayDate, toUtcDate } from '../../../libs/date';
import Dropzone from '../../Dropzone';
import { BASE_URL } from "../../../config";
import Spinner from '../../Spinner';

@inject('inventoryProductStore', 'inventoryItemStore', 'stationStore', 'inventorySupplierStore')
@observer
class InventoryProduct extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  @observable stationInventoryItems = [];
  @observable selectedItem = {
    id: null,
    model_no: '',
    product_name: '',
    serial_no: '',
    category: '',
    purchase_date: '',
    calibration_date: '',
    next_calibration_date: '',
    install_date: '',
    warranty_date: '',
    manufacturer: '',
    supplier: '',
    image: null,
    relatedFiles: [],
    movement: []
  };

  slug;
  movementSlug;

  constructor(props) {
    super(props);
    const { params: { id } } = props;
    this.handleDelete = this.handleDelete.bind(this);
    this.slug = `station/${id}/inventory/item`;
  }

  componentWillMount() {
    const { params: { id }, inventoryItemStore, inventoryProductStore, inventorySupplierStore } = this.props;

    if (!inventoryItemStore.isLoading && !inventoryItemStore.items.length) inventoryItemStore.fetchItems();
    if (!inventoryProductStore.isLoading && !inventoryProductStore.items.length) inventoryProductStore.fetchItems();
    if (!inventorySupplierStore.isLoading && !inventorySupplierStore.items.length) inventorySupplierStore.fetchItems();

    this.fetchStationItems();
  }

  fetchStationItems = () => {
    const { params: { id } } = this.props;
    api.stationInventory.item
      .list(id)
      .then(action(items => {
        this.stationInventoryItems = items
          .map(item => {
            return {
              ...item,
              // installation_date: moment(item.installation_date).format('l'),
              // purchase_date: moment(item.purchase_date).format('l'),
              // calibration_date: moment(item.calibration_date).format('l'),
              // next_calibration_date: moment(item.next_calibration_date).format('l'),
              installation_date: getDisplayDate(item.installation_date, { format: 'YYYY-MM-DD' }),
              purchase_date: getDisplayDate(item.purchase_date, { format: 'YYYY-MM-DD' }),
              calibration_date: getDisplayDate(item.calibration_date, { format: 'YYYY-MM-DD' }),
              next_calibration_date: getDisplayDate(item.next_calibration_date, { format: 'YYYY-MM-DD' }),
            };
          });
        this.selectedItem = {
          id: null,
          model_no: '',
          product_name: '',
          serial_no: '',
          category: '',
          purchase_date: '',
          calibration_date: '',
          next_calibration_date: '',
          install_date: '',
          warranty_date: '',
          manufacturer: '',
          supplier: '',
          image: null,
          relatedFiles: [],
          movement: []
        };
      }))
      .catch(err => {
        console.log('api.stationInventory.list', err);
      });
  };

  handleDelete(idOrIds) {
    const { notify } = this.context;

    api.stationInventory.item
      .remove(idOrIds)
      .then(notify.success)
      .catch(notify.error);
  }

  handleRelatedFileDelete = (fileId) => {
    const { notify } = this.context;
    let file = this.selectedItem.relatedFiles.filter(file => +file.id === +fileId)[0];
    api[file.type === 'item' ? 'inventoryItem' : 'inventoryProduct'].relatedFile
      .remove(this.selectedItem.id, fileId)
      .then(res => {
        this.selectedItem.relatedFiles = this.selectedItem.relatedFiles.filter(file => +file.id !== +fileId);
        notify.success(res);
      })
      .catch(console.log);
  };

  @action onSelectItem = e => this.fetchSelectedItem(e.id);

  fetchSelectedItem = (id) => {
    let { inventoryItemStore, inventoryProductStore, params } = this.props,
      item = inventoryItemStore.findById(id),
      product = inventoryProductStore.findById(item.product_id);
    this.movementSlug = `station/${params.id}/inventory/item-movement/${id}`;
    this.relatedFilesSlug = `station/${params.id}/inventory/related-files/${id}`;
    this.selectedItem = {
      id: id,
      model_no: product.code,
      product_name: product.name,
      serial_no: item.serial_no,
      category: product.pcategory_name,
      purchase_date: item.purchase_date,
      calibration_date: item.calibration_date,
      next_calibration_date: item.next_calibration_date,
      install_date: item.installation_date,
      warranty_date: item.warranty_date,
      manufacturer: product.manufacturer_name,
      supplier: product.supplier_name,
      images: [],
      relatedFiles: [],
      movement: []
    };
    api.inventoryItem.fetchById(id).then(item => {
      this.selectedItem.images = item.images;
      this.selectedItem.relatedFiles = item.file && item.file.length > 0 && item.file.map(file => {
        return ({
          id: file.file_id,
          file: <a download={`${file.original_name}`} href={`${BASE_URL}/files/${file.name}`} target="_blank">{file.original_name}</a>,
          type: file.type
        })
      })
    });
    api.inventoryItem.movement.get(id).then(movements => {
      movements && movements.length > 0 && movements.sort((a, b) => new Date(a.datetime).valueOf() > new Date(b.datetime).valueOf() ? 1 : -1).map(movement => {
        this.selectedItem.movement.push({
          id: movement.id,
          date: getDisplayDate(movement.datetime),
          remarks: movement.remarks
        });
      })
    });

  };

  render() {
    const { inventoryItemStore, inventoryProductStore, inventorySupplierStore } = this.props;

    if (inventoryItemStore.isLoading || inventoryProductStore.isLoading || inventorySupplierStore.isLoading) return <Spinner />

    return (
      <div className="inline-grid-reverse">
        <div className='flex-grow' style={{ maxWidth: '100%' }}>
          <div className='full-width overflow-x-scroll'>
            <DataTable
              caption={'Station Inventory Items'}
              data={this.stationInventoryItems}
              slug={this.slug}
              columns={[
                { key: 'id', label: 'ID' },
                { key: 'product_name', label: 'Product' },
                { key: 'pcategory_name', label: 'Category' },
                { key: 'serial_no', label: 'Serial No' },
                { key: 'installation_date', label: 'Installed Date' },
                { key: 'next_calibration_date', label: 'Next Calibration Date' },
              ]}
              // onDelete={this.handleDelete}
              allowAdd
              allowEdit
              // allowDelete
              onSelect={this.onSelectItem}
              parentSlug={`/station/${this.props.params.id}/inventory`}
              resource='inventory'
            />
          </div>

          <br />

          {this.selectedItem.id && <div className='full-width overflow-x-scroll'>
            <DataTable
              caption={`Item ${this.selectedItem.id} Movements`}
              data={this.selectedItem.movement.sort((a, b) => new Date(a.date).valueOf() - new Date(b.date).valueOf() > 0 ? -1 : 1)}
              slug={this.movementSlug}
              columns={[
                { key: 'date', label: 'Date' },
                { key: 'remarks', label: 'Remarks' },
              ]}
            />
          </div>}

          <br />

          {this.selectedItem.id && <div className='full-width overflow-x-scroll'>
            <DataTable
              caption={'Related Files'}
              data={this.selectedItem.relatedFiles}
              slug={this.relatedFilesSlug}
              columns={[
                { key: 'file', label: 'Related Files' },
              ]}
              onDelete={this.handleRelatedFileDelete}
              allowAdd
              allowDelete
              disableMultipleDelete
            />
          </div>}

          {this.props.children && React.cloneElement(this.props.children, { fetchStationItems: this.fetchStationItems, fetchSelectedItem: this.fetchSelectedItem })}
        </div>

        {this.selectedItem.id &&
          <div className="side-table" style={{ maxHeight: '100vh' }}>
            <div className='imageContainer' style={{ margin: '10px auto', width: 'fit-content' }}>
              {!!this.selectedItem.images && !!this.selectedItem.images[0] && <img src={`${BASE_URL}/images/${this.selectedItem.images[0].name}`} style={{ height: '200px' }} alt="not-found" />}
            </div>
            <div className='bordered'>
              <div className='DataTable'>
                <table>
                  <tbody>
                    <tr><th>Model No:</th><td>{this.selectedItem.model_no}</td></tr>
                    <tr><th>Product Name:</th><td>{this.selectedItem.product_name}</td></tr>
                    <tr><th>SNo.:</th><td>{this.selectedItem.serial_no}</td></tr>
                    <tr><th>Category:</th><td>{this.selectedItem.category}</td></tr>
                    <tr><th>Purchase Date:</th><td>{this.selectedItem.purchase_date}</td></tr>
                    <tr><th>Calibration Date:</th><td>{this.selectedItem.calibration_date}</td></tr>
                    <tr><th>Next Calibration Date:</th><td>{this.selectedItem.next_calibration_date}</td></tr>
                    <tr><th>Install Date:</th><td>{this.selectedItem.install_date}</td></tr>
                    <tr><th>Warranty Date:</th><td>{this.selectedItem.warranty_date}</td></tr>
                    <tr><th>Manufacturer:</th><td>{this.selectedItem.manufacturer}</td></tr>
                    <tr><th>Supplier:</th><td>{this.selectedItem.supplier}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
      </div>
    );
  }
}

export default InventoryProduct;



// WEBPACK FOOTER //
// ./src/components/Station/Inventory/StationInventoryList.js